import { Input } from '../../ui/input/input';
import { Button } from '../../ui/button/button';
import { useDispatch } from 'react-redux';
import { useCallback, useEffect, useRef, useState } from 'react';
import { dialogActions } from '../slice/dialog-slice';
import { FavoriteBrandItem } from '../../../slices/favorite-brand-slice';
import './change-favorite-brand-name.scss';
import { apiActions } from '../../../slices/api-slice';
import { ResponseBase } from '../../../api/response-base';
import { FavoriteGetResponse } from '../../../models/api/front/favorite';
import { ApiPrintFavoriteProductListGet } from '../../../api/sift/front/api-print-favorite-product-list-get';
import { ApiPrintFavoriteProductEdit } from '../../../api/sift/front/api-print-favorite-product-edit';

type ChangeFavoriteBrandNameProps = {
  kijshopCd: string,
  // - 更新する商品 -
  target: FavoriteBrandItem,
  // - ボタン押下後に表示するダイアログの種類 -
  type: 'config' | 'save',
  callback?: {
    onSuccess: () => void,
    onError: () => void,
  },
};
export const ChangeFavoriteBrandNameForPrint = (props: ChangeFavoriteBrandNameProps) => {
  const { kijshopCd, target, type, callback } = props;
  // - Hooks -
  const dispatch = useDispatch();
  // - State -
  // -- 名称 --
  const [name, setName] = useState(target.name);
  // - Callback -
  // -- 名称 --
  const handlerChangeName = useCallback((v) => {
    setName(v);
  }, []);
  // -- OKボタン押下 --
  const handlerClickOk = useCallback(async () => {
    if (!name) {
      dispatch(dialogActions.pushMessage({
        title: '確認',
        message: [
          'お気に入り商品名称を入力してください。',
        ],
        buttons: [
          {
            label: 'OK',
            callback: () => {
              dispatch(dialogActions.pop());
            },
          },
        ],
      }));
    } else {
      if (target.type === 'brand') {
        dispatch(apiActions.run(
          new ApiPrintFavoriteProductListGet({
            kijshopCd,
            folderId: target.parentId,
          }),
          {
            onSuccess: (res: ResponseBase<FavoriteGetResponse>) => {
              const arr = res?.body?.data?.favProductList || [];
              if (arr.find((v) => v.name === name)) {
                dispatch(dialogActions.pushMessage({
                  title: '確認',
                  message: [
                    '入力されたお気に入り商品名称は既に存在します。',
                    '別のお気に入り商品名称を入力してください。',
                  ],
                  buttons: [
                    {
                      label: 'はい',
                      callback: () => dispatch(dialogActions.pop()),
                    },
                  ],
                }));
              } else {
                dispatch(apiActions.run(
                  new ApiPrintFavoriteProductEdit({
                    kijshopCd,
                    favProductId: target.id,
                    name,
                    folderId: target.parentId,
                    level: target.level,
                    indexes: 0,
                  }),
                  {
                    onSuccess: callback?.onSuccess,
                    onError: callback?.onError,
                  },
                ));
              }
            },
            onError: callback?.onError,
          },
        ));
      } else {
        dispatch(dialogActions.pop());
      }
    }
  }, [name, type, target]);
  // -- キャンセルボタン押下 --
  const handlerClickCancel = useCallback(() => {
    dispatch(dialogActions.pop());
  }, [type]);
  const ref = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (ref.current) {
      ref.current.focus();
    }
  }, [ref.current]);
  return (
    <div className="dialog_contents change_favorite_brand_name">
      <div className="dialog_contents__body">
        <div>変更後のお気に入り商品名称を入力してください。</div>
        <div className="top_label_ui">
          <span>名称</span>
          <Input
            ref={ref}
            value={name}
            onChange={(e) => handlerChangeName(e.target.value)}
            maxLength={40}
          />
          <div className="top_label_ui__caution">※40文字以内で入力してください</div>
        </div>
      </div>
      <div className="dialog_contents__footer">
        <Button
          label="キャンセル"
          onClick={handlerClickCancel}
        />
        <Button
          label="OK"
          disabled={!name.length}
          onClick={handlerClickOk}
        />
      </div>
    </div>
  );
};
